import { useEffect, useState } from 'react'

function SolarpunkDecorations() {
  const [leaves, setLeaves] = useState([])

  useEffect(() => {
    const leafCount = 8
    const newLeaves = Array.from({ length: leafCount }, (_, i) => ({
      id: i,
      left: `${Math.random() * 100}%`,
      delay: `${Math.random() * 15}s`,
      duration: `${15 + Math.random() * 10}s`,
      size: `${25 + Math.random() * 25}px`,
    }))
    setLeaves(newLeaves)
  }, [])

  return (
    <div className="fixed inset-0 pointer-events-none overflow-hidden z-0">
      {/* 渐变光晕 */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-gradient-to-bl from-amber-300/30 via-green-300/20 to-transparent rounded-full blur-3xl transform translate-x-1/2 -translate-y-1/2"></div>
      
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-gradient-to-tr from-green-300/20 to-transparent rounded-full blur-3xl transform -translate-x-1/2 translate-y-1/2"></div>
      
      <div className="absolute top-1/4 left-1/4 w-[300px] h-[300px] bg-gradient-to-br from-sky-200/20 to-transparent rounded-full blur-2xl"></div>
      
      {/* 叶子装饰 */}
      <svg className="absolute top-20 left-10 w-20 h-20 text-green-400/40 animate-sway" viewBox="0 0 100 100">
        <path d="M50 10 C30 30, 20 60, 50 90 C80 60, 70 30, 50 10" fill="currentColor" />
      </svg>
      
      <svg className="absolute top-40 right-20 w-16 h-16 text-amber-400/40 animate-float" style={{ animationDelay: '1s' }} viewBox="0 0 100 100">
        <path d="M50 10 C30 30, 20 60, 50 90 C80 60, 70 30, 50 10" fill="currentColor" />
      </svg>
      
      <svg className="absolute bottom-40 left-20 w-24 h-24 text-green-400/40 animate-sway" style={{ animationDelay: '2s' }} viewBox="0 0 100 100">
        <path d="M50 10 C30 30, 20 60, 50 90 C80 60, 70 30, 50 10" fill="currentColor" />
      </svg>
      
      <svg className="absolute bottom-20 right-40 w-14 h-14 text-emerald-400/40 animate-float" style={{ animationDelay: '3s' }} viewBox="0 0 100 100">
        <path d="M50 10 C30 30, 20 60, 50 90 C80 60, 70 30, 50 10" fill="currentColor" />
      </svg>
      
      <svg className="absolute top-1/3 right-1/4 w-12 h-12 text-sky-400/40 animate-sway" style={{ animationDelay: '1.5s' }} viewBox="0 0 100 100">
        <path d="M50 10 C30 30, 20 60, 50 90 C80 60, 70 30, 50 10" fill="currentColor" />
      </svg>
      
      {/* 太阳 */}
      <div className="absolute top-5 right-10 w-48 h-48 opacity-25">
        <svg viewBox="0 0 100 100" className="w-full h-full">
          <defs>
            <radialGradient id="sunGradient" cx="50%" cy="50%" r="50%">
              <stop offset="0%" stopColor="#fbbf24" stopOpacity="1" />
              <stop offset="70%" stopColor="#f59e0b" stopOpacity="0.8" />
              <stop offset="100%" stopColor="#f59e0b" stopOpacity="0" />
            </radialGradient>
          </defs>
          
          <circle cx="50" cy="50" r="45" fill="url(#sunGradient)" />
          
          {[0, 45, 90, 135, 180, 225, 270, 315].map((angle) => (
            <polygon
              key={angle}
              points="50,50 47,20 53,20"
              fill="#fbbf24"
              opacity="0.6"
              transform={`rotate(${angle} 50 50)`}
            />
          ))}
          
          <circle cx="50" cy="50" r="25" fill="none" stroke="#fcd34d" strokeWidth="2" opacity="0.5" />
        </svg>
      </div>
      
      {/* 藤蔓曲线1 - 带叶片 */}
      <svg className="absolute top-1/4 left-5 w-40 h-40 text-green-400/30" viewBox="0 0 100 100" preserveAspectRatio="none">
        {/* 主藤蔓 */}
        <path 
          d="M10,90 C20,80 25,60 35,55 S50,40 55,35 S70,20 90,10" 
          fill="none" 
          stroke="currentColor" 
          strokeWidth="2" 
          strokeLinecap="round"
        />
        {/* 叶片1 */}
        <g transform="translate(25, 65) rotate(-30)">
          <path d="M0,0 C-5,-8 -3,-15 0,-18 C3,-15 5,-8 0,0" fill="currentColor" opacity="0.7" />
        </g>
        {/* 叶片2 */}
        <g transform="translate(40, 48) rotate(20)">
          <path d="M0,0 C-6,-10 -4,-18 0,-22 C4,-18 6,-10 0,0" fill="currentColor" opacity="0.6" />
        </g>
        {/* 叶片3 */}
        <g transform="translate(60, 32) rotate(-15)">
          <path d="M0,0 C-5,-8 -3,-14 0,-17 C3,-14 5,-8 0,0" fill="currentColor" opacity="0.5" />
        </g>
        {/* 叶片4 */}
        <g transform="translate(75, 20) rotate(25)">
          <path d="M0,0 C-4,-7 -2,-12 0,-15 C2,-12 4,-7 0,0" fill="currentColor" opacity="0.4" />
        </g>
      </svg>
      
      {/* 藤蔓曲线2 - 带叶片 */}
      <svg className="absolute bottom-1/4 right-10 w-48 h-48 text-green-400/30" viewBox="0 0 100 100" preserveAspectRatio="none">
        {/* 主藤蔓 */}
        <path 
          d="M5,95 C15,85 20,70 30,60 S45,45 55,40 S70,30 85,20 S95,10 98,5" 
          fill="none" 
          stroke="currentColor" 
          strokeWidth="2" 
          strokeLinecap="round"
        />
        {/* 次藤蔓 */}
        <path 
          d="M15,90 C25,75 35,65 45,55 S60,40 70,35" 
          fill="none" 
          stroke="currentColor" 
          strokeWidth="1.5" 
          strokeLinecap="round"
        />
        {/* 叶片1 */}
        <g transform="translate(20, 75) rotate(-25)">
          <path d="M0,0 C-6,-12 -4,-20 0,-24 C4,-20 6,-12 0,0" fill="currentColor" opacity="0.7" />
        </g>
        {/* 叶片2 */}
        <g transform="translate(38, 55) rotate(15)">
          <path d="M0,0 C-5,-10 -3,-16 0,-20 C3,-16 5,-10 0,0" fill="currentColor" opacity="0.6" />
        </g>
        {/* 叶片3 */}
        <g transform="translate(55, 38) rotate(-20)">
          <path d="M0,0 C-6,-11 -4,-18 0,-22 C4,-18 6,-11 0,0" fill="currentColor" opacity="0.5" />
        </g>
        {/* 叶片4 */}
        <g transform="translate(72, 25) rotate(30)">
          <path d="M0,0 C-5,-9 -3,-15 0,-18 C3,-15 5,-9 0,0" fill="currentColor" opacity="0.4" />
        </g>
        {/* 叶片5 - 次藤蔓上 */}
        <g transform="translate(32, 62) rotate(10)">
          <path d="M0,0 C-4,-8 -2,-13 0,-16 C2,-13 4,-8 0,0" fill="currentColor" opacity="0.5" />
        </g>
        {/* 叶片6 - 次藤蔓上 */}
        <g transform="translate(52, 45) rotate(-5)">
          <path d="M0,0 C-5,-9 -3,-14 0,-17 C3,-14 5,-9 0,0" fill="currentColor" opacity="0.4" />
        </g>
      </svg>
      
      {/* 横向藤蔓 - 带叶片 */}
      <svg className="absolute top-1/2 left-0 w-32 h-32 text-green-400/20" viewBox="0 0 100 100" preserveAspectRatio="none">
        {/* 主藤蔓 */}
        <path 
          d="M0,50 C10,45 20,55 30,50 S50,40 60,45 S80,50 100,45" 
          fill="none" 
          stroke="currentColor" 
          strokeWidth="1.5" 
          strokeLinecap="round"
        />
        {/* 叶片1 */}
        <g transform="translate(20, 52) rotate(60)">
          <path d="M0,0 C-4,-7 -2,-12 0,-15 C2,-12 4,-7 0,0" fill="currentColor" opacity="0.6" />
        </g>
        {/* 叶片2 */}
        <g transform="translate(45, 43) rotate(-50)">
          <path d="M0,0 C-5,-8 -3,-13 0,-16 C3,-13 5,-8 0,0" fill="currentColor" opacity="0.5" />
        </g>
        {/* 叶片3 */}
        <g transform="translate(70, 47) rotate(55)">
          <path d="M0,0 C-4,-7 -2,-11 0,-14 C2,-11 4,-7 0,0" fill="currentColor" opacity="0.4" />
        </g>
      </svg>
      
      {/* 额外的小藤蔓装饰 */}
      <svg className="absolute top-2/3 right-1/4 w-24 h-24 text-green-400/20" viewBox="0 0 100 100" preserveAspectRatio="none">
        <path 
          d="M10,90 C25,75 40,60 50,50 S70,30 90,15" 
          fill="none" 
          stroke="currentColor" 
          strokeWidth="1.5" 
          strokeLinecap="round"
        />
        <g transform="translate(30, 70) rotate(-35)">
          <path d="M0,0 C-4,-7 -2,-11 0,-14 C2,-11 4,-7 0,0" fill="currentColor" opacity="0.5" />
        </g>
        <g transform="translate(55, 42) rotate(20)">
          <path d="M0,0 C-3,-6 -2,-10 0,-12 C2,-10 3,-6 0,0" fill="currentColor" opacity="0.4" />
        </g>
      </svg>
      
      {/* 垂直生长线 */}
      <div className="absolute top-0 left-1/4 w-1 h-40 bg-gradient-to-b from-green-300/30 to-transparent rounded-full"></div>
      <div className="absolute top-0 left-1/2 w-1 h-28 bg-gradient-to-b from-amber-300/20 to-transparent rounded-full"></div>
      <div className="absolute top-0 right-1/4 w-1 h-36 bg-gradient-to-b from-sky-300/20 to-transparent rounded-full"></div>
      
      {/* 太阳能网格 */}
      <div className="absolute inset-0 solar-grid"></div>
      
      {/* 飘落的叶子 */}
      {leaves.map((leaf) => (
        <div
          key={leaf.id}
          className="absolute text-green-400/25"
          style={{
            left: leaf.left,
            top: '-50px',
            width: leaf.size,
            height: leaf.size,
            animation: `leaf-fall ${leaf.duration} linear infinite`,
            animationDelay: leaf.delay,
          }}
        >
          <svg viewBox="0 0 100 100" className="w-full h-full">
            <path d="M50 10 C30 30, 20 60, 50 90 C80 60, 70 30, 50 10" fill="currentColor" />
          </svg>
        </div>
      ))}
    </div>
  )
}

export default SolarpunkDecorations
